var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background_container_ipad"},[_c('div',{staticClass:"mobile_view_container"},[_c('LoginMobile')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }